@import '../../style/globals.scss';

.InformationDrawer {
    position: absolute;
    z-index: 10;
    top: 0;
    right: -$sidebar-width;
    width: 100%;
    height: 100%;
    background-color: var(--token-accent-theme-1-interface-mono-interface-black);
    color: var(--token-accent-theme-1-text-text-default);
    transition: $sidebar-transition, opacity 0s linear 0.5s;
    opacity: 0;
    font-weight: bold;

    @media (max-width: $bp-mobile-chat) {
        right: -100%;
        width: 100%;
    }

    &.isOpen {
        right: 0;
        transition: $sidebar-transition, opacity 0s linear 0s;
        opacity: 1;
    }

    .scrollContainer {
        @include scrollbar-styles;
        position: relative;
        overflow-y: auto;
        width: 100%;
        height: 100%;
        padding-top: 60px;
        background-position: center top;
        background-size: 100%;
        background-repeat: no-repeat;
        text-align: center;

        @media (max-width: $bp-s) {
            padding-top: 30px;
        }
    }

    .contentContainer {
        height: 100%;
        width: 100%;
    }

    .closeButton {
        position: absolute;
        top: 10px;
        right: 10px;
    }
}
